var _path, _path2, _path3, _path4, _circle, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _circle2, _circle3, _ellipse, _ellipse2, _ellipse3, _path12;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCartEmpty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 448,
    height: 227,
    viewBox: "0 0 448 227",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M75.0039 8C66.1674 8 59.0039 15.1634 59.0039 24C59.0039 30.8898 63.3587 36.7624 69.4658 39.0156H41.0039C32.1674 39.0156 25.0039 46.1791 25.0039 55.0156C25.0039 63.8522 32.1674 71.0156 41.0039 71.0156H70.4871C64.3688 73.2631 60.0039 79.1413 60.0039 86.0391C60.0039 93.4383 65.0266 99.6645 71.8484 101.494H119.004C127.84 101.494 135.004 108.658 135.004 117.494C135.004 126.331 127.84 133.494 119.004 133.494H94H16C7.16344 133.494 0 140.658 0 149.494C0 158.331 7.16344 165.494 16 165.494H44.4237C38.3386 167.759 34.0039 173.62 34.0039 180.494C34.0039 186.518 37.3331 191.765 42.2519 194.494H41.0039C32.1674 194.494 25.0039 201.658 25.0039 210.494C25.0039 219.331 32.1674 226.494 41.0039 226.494H371.018C379.854 226.494 387.018 219.331 387.018 210.494C387.018 204.47 383.688 199.224 378.77 196.494H380.018C388.854 196.494 396.018 189.331 396.018 180.494C396.018 173.62 391.683 167.759 385.598 165.494H308.004C299.167 165.494 292.004 158.331 292.004 149.494C292.004 140.658 299.167 133.494 308.004 133.494H354H432C440.837 133.494 448 126.331 448 117.494C448 110.62 443.665 104.759 437.58 102.494H349.004C340.167 102.494 333.004 95.3307 333.004 86.4941C333.004 77.6576 340.167 70.4941 349.004 70.4941H384.073C390.939 68.6948 396.005 62.4468 396.005 55.0156C396.005 48.1259 391.651 42.2532 385.544 40H409.005C417.842 40 425.005 32.8366 425.005 24C425.005 15.1634 417.842 8 409.005 8H75.0039Z",
    fill: "var(--primary-muted)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M141.004 48.4941H164.26C167.04 48.4941 169.457 50.4048 170.098 53.1105L173.862 68.9941M189.504 134.994H274.52C275.401 134.994 276.179 134.417 276.434 133.574L295.222 71.5741C295.611 70.2898 294.65 68.9941 293.308 68.9941H173.862M189.504 134.994L173.862 68.9941M189.504 134.994C189.504 134.994 179.004 134.994 179.004 144.994C179.004 154.994 189.504 154.994 189.504 154.994H276.004",
    stroke: "var(--primary)",
    strokeWidth: 8,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M209.004 94.4941C209.004 94.4941 213.004 98.3956 218.004 98.4941C223.504 98.6025 227.504 94.4941 227.504 94.4941",
    stroke: "var(--primary)",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M239.004 94.4941C239.004 94.4941 243.004 98.3956 248.004 98.4941C253.504 98.6025 257.504 94.4941 257.504 94.4941",
    stroke: "var(--primary)",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 232.504,
    cy: 112.994,
    r: 3.5,
    fill: "var(--primary)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M212.004 174.494C212.004 182.226 205.736 188.494 198.004 188.494C190.272 188.494 184.004 182.226 184.004 174.494C184.004 166.762 190.272 160.494 198.004 160.494C205.736 160.494 212.004 166.762 212.004 174.494ZM191.004 174.494C191.004 178.36 194.138 181.494 198.004 181.494C201.87 181.494 205.004 178.36 205.004 174.494C205.004 170.628 201.87 167.494 198.004 167.494C194.138 167.494 191.004 170.628 191.004 174.494Z",
    fill: "var(--primary)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M280.004 174.494C280.004 182.226 273.736 188.494 266.004 188.494C258.272 188.494 252.004 182.226 252.004 174.494C252.004 166.762 258.272 160.494 266.004 160.494C273.736 160.494 280.004 166.762 280.004 174.494ZM259.004 174.494C259.004 178.36 262.138 181.494 266.004 181.494C269.87 181.494 273.004 178.36 273.004 174.494C273.004 170.628 269.87 167.494 266.004 167.494C262.138 167.494 259.004 170.628 259.004 174.494Z",
    fill: "var(--primary)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M102 4.65854L111.924 1.00675C111.931 1.00393 111.939 1.01096 111.937 1.01881L106.645 20.0056C106.643 20.0134 106.65 20.0205 106.658 20.0176L116.581 16.3659",
    stroke: "var(--secondary)",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M122.059 19.2928L128.668 17.1039C128.675 17.1013 128.683 17.1088 128.68 17.1166L124.054 30.9804C124.051 30.9883 124.059 30.9958 124.066 30.9929L132 28.0733",
    stroke: "var(--secondary)",
    strokeWidth: 1.6,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M302.004 196.701L304.763 207.736",
    stroke: "var(--secondary)",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M306.142 194.631L308.9 197.389",
    stroke: "var(--secondary)",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M308.9 190.494L321.314 194.632",
    stroke: "var(--secondary)",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 297.555,
    cy: 182.77,
    r: 8.27586,
    fill: "var(--secondary-muted)"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 285.142,
    cy: 202.081,
    r: 4.13793,
    fill: "var(--secondary-muted)"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 7.71885,
    cy: 7.71911,
    rx: 7.71885,
    ry: 7.71911,
    transform: "matrix(-1 0 0 1 305.44 43.8965)",
    fill: "var(--secondary-muted)"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 2.80685,
    cy: 2.80695,
    rx: 2.80685,
    ry: 2.80695,
    transform: "matrix(-1 0 0 1 318.072 50.9141)",
    fill: "var(--secondary-muted)"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 2.80685,
    cy: 2.80695,
    rx: 2.80685,
    ry: 2.80695,
    transform: "matrix(-1 0 0 1 313.861 63.5449)",
    fill: "var(--secondary-muted)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M318.407 46.4063L317.004 41.4941M321.916 48.5115L326.828 44.3011M323.319 54.1254L329.635 54.8272",
    stroke: "var(--secondary)",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCartEmpty);
export default __webpack_public_path__ + "static/media/CartEmpty.621ffb0c800f592d52624ce408cbbe1a.svg";
export { ForwardRef as ReactComponent };